import { ControllerBase } from "./base";
import { PrizeModel } from "../models/prize";

class _PrizeController extends ControllerBase {
    prizes = [];

    constructor() {
        super();
    }

    setPrizes(prizes) {
        this.prizes = [];

        prizes.forEach(prize => {
            this.prizes.push(new PrizeModel({
                id: prize.prizeID,
                uid: prize.prizeUID,
                booby: false
            }))
        });

        this.prizes.push(new PrizeModel({
            id: "",
            uid: "",
            booby: true
        }))
    }
}

export const PrizeController = new _PrizeController();